import BookingItem from '@/booking/models/BookingItem';
import { isPresent, present } from '@/shared/utils/typescript';
import PlannerDossier from '../models/PlannerDossier';

function formatAppointmentItem(item: BookingItem): object {
  return {
    id: item.id,
    type: item.type,
    description: item.description,
    longDescription: item.longDescription,
    code: item.code,
    price: item.price,
    duration: item.laborMinutes,
  };
}

export function formatPlannerDossier(plannerDossier: PlannerDossier): object {
  const outlet = present(plannerDossier.outlet);
  const vehicle = present(plannerDossier.vehicle);

  return {
    moboOutletId: outlet.id,
    teamId: plannerDossier.team?.id ?? null,
    dealerObjectDataId: vehicle.id,
    registrationNumber: vehicle.registrationNumber,
    modelDescription: vehicle.modelDescription,
    brandId: present(vehicle.brand).id,
    mileage: plannerDossier.mileage === 0 ? null : plannerDossier.mileage,
    mobilitySolutionId: !plannerDossier.waitsOnPremise ? plannerDossier.mobilitySolution?.id : null,
    mobilitySolutionReference: !plannerDossier.waitsOnPremise ? plannerDossier.mobilitySolution?.description : '',
    waitsOnPremise: plannerDossier.waitsOnPremise,
    appointmentItems: plannerDossier.bookingItems.map(formatAppointmentItem),
    workshopPlanningIndicators: plannerDossier.planningTags.map(t => t.id),
    contactInformation: (!isPresent(vehicle.id) && vehicle.customers.length > 0) ? vehicle.customers[0].fullName : '',
  };
}